// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__XELKc","accent":"Logo_accent__gtFI4"};